// This file is automatically generated. Do not edit manually.

import { ReclamationView } from "src/api/generated/erp/db/types/tables/reclamationView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SingleReclamationViewApi {
	export async function getSingleReclamationViewData(args: {
		reclamationId: number;
	}): Promise<SingleReclamationViewApi_Data> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/singleReclamationView/getSingleReclamationViewData",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as SingleReclamationViewApi_Data;
	}
}

export interface SingleReclamationViewApi_Data {
	reclamation: ReclamationView;
}
